import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useLocation, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

import DeviceForm from './DeviceForm';

const message = defineMessages({
    objectName: 'Device kitplay',
});

const DeviceSavePage = () => {
    const translate = useTranslate();
    const params = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const deviceId = queryParams.get('deviceId');
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const ordering = queryParams.get('ordering');
    const collapseId = queryParams.get('collapseId');
    const collapseParam = collapseId ? `&collapseId=${collapseId}` : '';

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.kitplayDevice.getById,
            create: apiConfig.printer.create,
            update: apiConfig.printer.update,
        },
        options: {
            getListUrl: generatePath(routes.deviceTabsRestaurantListPage.path, { customerId: params.customerId }) + `?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}${collapseParam}`,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                    parentId: deviceId,
                    restaurantId,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    parentId: deviceId,
                    restaurantId,
                    ordering: ordering ? Number(ordering) + 1 : undefined,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code ?? err.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(translate.formatMessage(errorMessage), translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.digibesShop),
                    path: routes.shopAccountListPage.path,
                },
                {
                    breadcrumbName: translate.formatMessage(commonMessage.restaurant),
                    path: generatePath(routes.RestaurantByCustomerListPage.path,{ customerId: params.customerId }),
                },
                {
                    breadcrumbName: restaurantName || translate.formatMessage(commonMessage.devices),
                    path: `${generatePath(routes.deviceTabsRestaurantListPage.path, {
                        customerId: params.customerId,
                    })}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}${collapseParam}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <DeviceForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default DeviceSavePage;
